import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToasterService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const canActivate: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const urls = ['/bag', '/my-wishlist', '/view-profile', '/my-order', '/my-wallet'];
  const router = inject(Router);
  const toasterService = inject(ToasterService);
  const translateService = inject(TranslateService);

  if (urls.includes(state.url)) {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      const isAuthenticated =
        localStorage.getItem(environment.storageKey) !== null;
      const isGuestMode =
        sessionStorage.getItem(environment.guestTokenKey) !== null;
      const selectedLang = localStorage.getItem(environment.selectedLang);
      if (!isAuthenticated && isGuestMode) {
        selectedLang === 'ar' ? toasterService.errToastr(
          translateService.instant('انت تحتاج لتسجيل الدخول اولا')
        ) : toasterService.errToastr(
          translateService.instant('You need to login first')
        );
        router.navigateByUrl('/home-v2');
        return false;
      }
    }
  }
  return true;
};
